import React from 'react';
import styled from '@emotion/styled';
import { mediaQueries } from 'components/mediaQueries';
import { MiniArticleCard as MiniArticleCardType } from 'data/global/types';
import { MiniArticleCard } from 'components/Cards/MiniArticleCard/MiniArticleCard';

type Props = { articles: MiniArticleCardType[] };

export const MiniArticleCards = ({ articles }: Props) => {
  if (!articles.length) {
    return null;
  }

  return (
    <List>
      {articles.map((article: MiniArticleCardType, index: number) => {
        if (index < 5)
          return (
            <li key={index}>
              <MiniArticleCard article={article} />
            </li>
          );
      })}
    </List>
  );
};

const List = styled.ul`
  display: grid;
  grid-row-gap: 10px;
  ${mediaQueries.tablet} {
    grid-row-gap: 15px;
    min-width: 100%;
    width: 100%;
  }
  ${mediaQueries.desktop} {
    grid-template-columns: repeat(5, min-content);
    grid-column-gap: 20px;
    min-width: 100%;
    width: 1200px;
  }
`;
